export const VIDEO_CONFIG = {
    // Replace this with your actual Loom video URL
    LOOM_VIDEO_URL: "https://www.loom.com/embed/e42657859d7146199f966b491d868273?sid=9a43fad6-db5a-4ef1-8c69-0e33551d4acd&hideEmbedTopBar=true",
    
    // Video popup settings
    POPUP_DELAY_MS: 0, // Show immediately after login
    
    // Video popup content
    TITLE: "Welcome to Doctors' Jobs!",
    DESCRIPTION: "Watch this quick overview to get started with finding your next medical position.",
    
    // Local storage key
    FIRST_TIME_USER_KEY: "doctor-jobs-first-time-user"
}; 